import React, { useEffect, useState } from 'react';
import { NavLink, Outlet, useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useAddresses } from '../context/AddressContext';
import api from '../api';
import './PackageLayout.css';

export default function PackageLayout() {
  const { id } = useParams();
  const { username, logout } = useAuth();
  const { setAddresses } = useAddresses();
  const navigate = useNavigate();
  const [packName, setPackName] = useState('');

  useEffect(() => {
    api.get(`/packages/${id}`).then(res => {
      setPackName(res.data.package.name);
    }).catch(() => {
      navigate('/');
    });

    // Load addresses into the shared context as soon as we enter a pack so
    // that every tab (Bank Statements, Scope of Work, Leases, etc.) sees
    // them on first render and after a hard refresh, without having to
    // bounce through the Addresses tab first.
    api.get(`/addresses/${id}`).then(res => {
      setAddresses(res.data.addresses || []);
    }).catch(() => {
      setAddresses([]);
    });
  // setAddresses is stable; intentionally re-running only on id change
  // eslint-disable-next-line
  }, [id]);

  const tabs = [
    { path: `/pack/${id}`, label: 'Addresses', end: true },
    { path: `/pack/${id}/scope`, label: 'Scope of Work' },
    { path: `/pack/${id}/leases`, label: 'Leases' },
    { path: `/pack/${id}/bank-statements`, label: 'Bank Statements' },
    { path: `/pack/${id}/closing-packs`, label: 'Closing Packs' },
    { path: `/pack/${id}/settlement-statements`, label: 'Settlement Statements' },
    { path: `/pack/${id}/payoff-calculator`, label: 'Payoff Calculator' },
    { path: `/pack/${id}/lease-ledgers`, label: 'Lease Ledgers' },
    { path: `/pack/${id}/package-export`, label: 'Package Export' },
  ];

  return (
    <div className="layout">
      <header className="topbar">
        <button className="btn-back" onClick={() => navigate('/')}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
          </svg>
        </button>
        <div className="topbar-brand">{packName || 'Loading...'}</div>
        <nav className="topbar-nav">
          {tabs.map(tab => (
            <NavLink
              key={tab.path}
              to={tab.path}
              end={tab.end}
              className={({ isActive }) => `nav-tab ${isActive ? 'active' : ''}`}
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
        <div className="topbar-user">
          <span>{username}</span>
          <button onClick={logout} className="btn-logout">Logout</button>
        </div>
      </header>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
